import React from 'react';

const SuggestionsBlock = ({ title, suggestions, onSuggestionClick }) => (
  <div className="border border-gray-200 rounded-lg overflow-hidden">
    <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
      <h4 className="font-medium text-gray-900">{title}</h4>
    </div>
    <div className="p-4">
      <div className="flex flex-wrap gap-2">
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            onClick={() => onSuggestionClick?.(suggestion)}
            className="px-4 py-2 text-sm bg-blue-50 hover:bg-blue-100 text-blue-700 rounded-lg transition-colors border border-blue-200 hover:border-blue-300 hover:shadow-sm"
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  </div>
);

export default SuggestionsBlock;
